import React, { useState } from "react";
import { DEMO_POSTS } from "data/posts";
import { PostDataType } from "data/types";
import SocialsList from "components/SocialsList/SocialsList";
import NcImage from "components/NcImage/NcImage";
import { GlobeAltIcon, ShareIcon } from "@heroicons/react/24/outline";
import VerifyIcon from "components/VerifyIcon";
import "../../styles/styles.css";

const posts: PostDataType[] = DEMO_POSTS.filter((_, i) => i < 12);
const FILTERS = [
  { name: "Most Recent" },
  { name: "Curated by Admin" },
  { name: "Most Appreciated" },
  { name: "Most Discussed" },
  { name: "Most Viewed" },
];
const TABS = ["Articles", "Favorites", "Saved"];

const PagePrix = () => {
  const [tabActive, setTabActive] = useState<string>(TABS[0]);

  const handleClickTab = (item: string) => {
    if (item === tabActive) {
      return;
    }
    setTabActive(item);
  };

  return (
 
      <div className="bgColor text-white">
      
        <div className="relative h-20 md:h-60 2xl:h-30">
          
          <NcImage
            alt=""
            containerClassName="absolute inset-0"
            sizes="(max-width: 1280px), 100vw, 1536px"
            src="../../images/Forfaits.jpg"
            className=""
            fill
          />
          <h2 className="inline-block align-middle text-4xl font-semibold md:text-5xl"
              style={{position: "absolute",
                      top: "20%",
                      left: "50%",
                      transform: "translate(-20%, -50%)"}}>
            Forfaits
          </h2>
          
        
        </div>
           
        <div style={{padding:"50px" }} className="wrap">
         
          <div  className="moitie column relative bg-white dark:bg-neutral-900 dark:border dark:border-neutral-700 p-5 lg:p-4 rounded-3xl md:rounded-[40px] shadow-xl">
            {/*  */}
            <div  className="pt-5 lg:ml-6 xl:ml-12 flex-grow flex-col">
              <div className="max-w-screen-sm space-y-3.5 ">
                <h2 className="center inline-flex items-center text-2xl sm:text-3xl lg:text-4xl font-semibold">
                  <span>Photos et vidéos aériennes</span>
                  <VerifyIcon
                    className="ml-2"
                    iconClass="w-6 h-6 sm:w-7 sm:h-7 xl:w-8 xl:h-8"
                  />
                </h2>
                
                <ul className="circle">
                  <li>Photographies aériennes 4K</li>
                  <li>Vidéo aériennes 4K</li>
                </ul>
                
              </div>
            </div>
          </div>
          <div style={{padding:"50px" }}></div>
          <div className="moitie center column relative bg-white dark:bg-neutral-900 dark:border dark:border-neutral-700 p-5 lg:p-4 rounded-3xl md:rounded-[40px] shadow-xl flex">
            <div className="center pt-5 lg:ml-6 xl:ml-12 flex-grow">
              <div className="center max-w-screen-sm space-y-3.5 ">
                <h2 className="inline-flex items-center text-2xl sm:text-3xl lg:text-4xl font-semibold">
                  <span>Photos, vidéos et montage</span>
                  <VerifyIcon
                    className="ml-2"
                    iconClass="w-6 h-6 sm:w-7 sm:h-7 xl:w-8 xl:h-8"
                  />
                </h2>
                <ul className="circle">
                  <li>Photographies aériennes 4K</li>
                  <li>Vidéo aériennes 4K</li>
                  <li>Montage vidéo</li>
                </ul>
                
              </div>
              
            </div>
            
          </div>
          
        </div>
        <br/>
        <br/>
        <br/>
      </div>
  
  );
};

export default PagePrix;
